import React from 'react';

type SvglastviewedProps = React.SVGProps<SVGSVGElement>;

const Svglastviewed: React.FC<SvglastviewedProps> = (props) => (
  <svg
    {...props}
    height="24"
    width="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14 3V7C14 7.55229 14.4477 8 15 8H19"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.90909"
    />
    <path
      d="M17 21H7C5.89543 21 5 20.1046 5 19V5C5 3.89543 5.89543 3 7 3H14L19 8V19C19 20.1046 18.1046 21 17 21Z"
      fillRule="evenodd"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.90909"
    />
    <path
      d="M9 9H10"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.90909"
    />
    <path
      d="M9 13H15"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.90909"
    />
    <path
      d="M9 17H15"
      stroke="#5F6D7E"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.90909"
    />
  </svg>
);

export default Svglastviewed;
